<template>
    <ScheduleTrigger :date="formattedDate" :scheduled="isScheduled" @click="scheduleFollowupDialog?.open()" />
    <ScheduleFollowupDialog ref="scheduleFollowupDialog" :initial-date="initialDate" :event-description="inviteDescription" :custom-schedule="scheduleFollowup" />
</template>

<script setup lang="ts">
import { useScheduleFollowup } from "~vue/composables/useScheduleFollowup.js";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject, onMounted, useTemplateRef } from "vue";

import ScheduleFollowupDialog from "./components/ScheduleFollowupDialog.vue";
import ScheduleTrigger from "./components/ScheduleTrigger.vue";
import type { ParseActionsFollowUpAction } from "./types/chat";

const coachingSessionUuid = inject<string>("coachingSessionUuid", "");

type ChatActionFollowupInSidebarProps = {
    data: ParseActionsFollowUpAction;
    messageId: number;
    lineIdx: number;
};

const { data, messageId, lineIdx } = defineProps<ChatActionFollowupInSidebarProps>();

const { initialDate, formattedDate, scheduleFollowup, isScheduled, inviteDescription } = useScheduleFollowup({
    line: data,
    messageId,
    lineIdx,
    source: "chat_sidebar",
});

onMounted(() => {
    logUserInteraction("followup_presented", { chat_message_id: messageId }, coachingSessionUuid);
});

const scheduleFollowupDialog = useTemplateRef("scheduleFollowupDialog");
</script>
